// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"213":"1e42fd74","239":"415e5cbb","667":"f398a1ce"}[chunkId] + ".chunk.js";
};